import { useQuery } from "@tanstack/react-query";
import { getAllEmployeePermission } from "../../services/employee/employee-permission-service";

export const useGetAllEmployeePermission = (page, limit) => {
return useQuery({
queryKey: ["get-employee-permission",page, limit],
queryFn: async () => {
const response = await getAllEmployeePermission({page, limit});

if (!response.success) {
throw new Error(response.message || "Failed to fetch permissions");
}

return response.data;
},
});
};